import SelectButton from "./SelectButton";
import SelectPanel from "./SelectPanel";

export default {
    button: SelectButton,
    name: "select",
    panel: SelectPanel,
};
